import Vue from 'vue'
import Antd from 'ant-design-vue/lib'
// import { notification, message } from 'ant-design-vue'
import notification from 'ant-design-vue/lib/notification'
import message from 'ant-design-vue/lib/message'
import zhCN from 'ant-design-vue/lib/locale/zh_CN'

// 复制插件
import VueClipboard from 'vue-clipboard2'
import VImg from '../components/base/vImg/index'
// 图片配置

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(VImg)

Vue.$message = message
Vue.$notify = notification
Vue.prototype.$locale = zhCN
Vue.use(Antd)

// https://www.antdv.com/components/icon-cn/#components-icon-demo-use-iconfont.cn 导入iconfont.cn的链接
